// extracted by mini-css-extract-plugin
export default {"timeStamp":"style--timeStamp--29dd57"};